import { Container, Row, Col, Table, Button, Modal, ProgressBar, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { BsFillTrashFill } from 'react-icons/bs'
import AddUserForm from "../AddUserForm";
import Actions from "../../redux/actions";
import API from "../../api/api";
export default function AddUsers() {

    const user = useSelector(state => state.user)
    const [users, setUsers] = useState([])
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false)
    const [step, setStep] = useState(0)
    const dispatch = useDispatch()
    const _submit = (user) => {
        setUsers([...users, user])
        setShow(false)
    }

    const _remove = (index) => {
        setUsers(users.filter((user, i) => index !== i))
    }

    const _next = async () => {
        setLoading(true)
        for (const user of users) {
            const data = await API.addUser(user)

            setStep(prev => prev + 1)
            await new Promise(resolve => {
                setTimeout(() => {
                    resolve()
                }, 400)
            })
        }
        setLoading(false)
        dispatch(Actions.setToast(`✅ ${users.length} User${users.length > 1 ? 's' : ''} Created`, 'Each user received an email with signup instructions.'))
        dispatch(Actions.setSignupStep(7))
    }

    const _show = () => {
        if (users.length === user?.licenses) {
            dispatch(Actions.setToast('🚨 Too Many Users 🚨', `You purchased ${user?.licenses} devices. You can add more users and devices later!`))
        } else {
            setShow(true)
        }
    }

    return (
        <Container className='p-3'>
            <Row>
                <Col md={8} className={`bg-white border shadow rounded my-auto mx-auto animate__animated animate__fadeIn p-3 px-5`}>
                    <h1 className='display-4 text-primary font-weight-bold'><b>Invite Your Users</b></h1>
                    <p className='px-5'>Invite up to <span className='weight-bold text-primary'>{user?.licenses}</span> users to join under your account. You will receive text updates if they go to dangerous sites, manage their devices, and grant temporary access if needed.</p>

                    <div className='text-end mt-3'>
                        <Button onClick={_show}>Create</Button>
                    </div>
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {users?.map((user, index) => (
                                <tr>
                                    <td>{user?.fName}</td>
                                    <td>{user?.lName}</td>
                                    <td>{user?.email}</td>
                                    <td><BsFillTrashFill className='text-primary pointer' onClick={() => _remove(index)}></BsFillTrashFill></td>
                                </tr>
                            ))}


                        </tbody>
                    </Table>

                    {loading && <>
                        <p>Adding Users...</p>
                        <ProgressBar className='mt-3' now={Math.floor((step / users.length) * 100)} />
                        <div className='text-center mt-3'>
                            <Spinner animation='border' />
                        </div>
                    </>}
                    {users?.length === 0 && <p className='text-center'>Click the 'Create' Button to Add a User</p>}

                    <Button className='my-2' onClick={_next} disabled={users.length === 0}>Next</Button>
                    <br />
                    <Button variant='link' onClick={() => dispatch(Actions.setSignupStep(7))}>Skip For Now</Button>
                </Col>
            </Row>

            <Modal show={show} onHide={() => setShow(false)} size='md'>
                <Modal.Header closeButton>
                    <Modal.Title>Create New User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddUserForm signup={true} close={() => setShow(false)} submit={_submit} />
                </Modal.Body>

            </Modal>

        </Container>
    )
}